import type { ReactNode } from "react";
import { useAccount } from "wagmi";
import { GameProvider } from "@looksrare/uikit";
import { ChainId } from "@looksrare/config";
import { PtbConfig } from "@looksrare/poke-the-bear";
import { isBefore } from "date-fns/isBefore";
import { gameAddresses } from "@/config";
import { useGlobalSettings } from "@/hooks";
import { useUser } from "@/queries/user";
import { BottomClaimPanel, PlayerListMeta } from "./PTB";

export const YoloGamesPtbProvider = ({ children }: { children: ReactNode }) => {
  const [isSoundEnabled, toggleMute] = useGlobalSettings((state) => [state.isSoundEnabled, state.toggleSound]);
  const { address } = useAccount();
  const { data: user } = useUser(address!, { enabled: !!address });

  return (
    <GameProvider<PtbConfig>
      widgetBotOptions={{
        server: "1204359490925764680",
        channel: "1204997205388427315",
        shard: "https://emerald.widgetbot.io",
        glyph: ["/images/win/chat.png", "32px"],
        color: "#CCFD07",
        notifications: false,
        indicator: true,
      }}
      supportedNetworks={["blast"]}
      addresses={gameAddresses}
      fallbackChainId={ChainId.BLAST_MAINNET}
      config={{
        refundCutoffSec: 24 * 60 * 60,
        hideCaveBackground: true,
        showLocalMuteButton: false,
        isMuted: !isSoundEnabled,
        hotNetwork: "blast",
        renderHistoryPageTopClaimBox: false,
        historyPageBottomComponent: () => <BottomClaimPanel />,
        historyPageWinnerProfileClickable: false,
        mobileClaimPanelComponent: () => <BottomClaimPanel />,
        showMobileHeader: false,
        mobileLobbyProps: { pt: 8, pb: 24 },
        playerListMetaComponent: (gemsEarned) => <PlayerListMeta gemsEarned={gemsEarned} />,
        actions: { toggleMute },
        selfTimeoutUntil: user?.selfTimeoutUntil,
        isWalletBlocked: !!user?.selfTimeoutUntil && isBefore(Date.now(), user.selfTimeoutUntil),
        points: {
          enabled: false,
        },
      }}
    >
      {children}
    </GameProvider>
  );
};
